export const DELIVERY_TYPES_MAP = {
  SHIPPING: "DELIVERY",
  PICKUP: "PICKUP",
}

export function getDeliveryType(val: string) {
  return DELIVERY_TYPES_MAP[val] || "NOT_SET"
}
